import Radio, { RadioProps } from "@mui/material/Radio";

export type EmtRadioProps = Omit<RadioProps, "color"> & {
  nonce?: string;
  color?: any;
};

export function EmtRadio(props: EmtRadioProps) {
  const { ...rest } = props;
  return <Radio disableRipple={true} {...rest} />;
}
